<script setup lang="ts">
import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { defineProps, inject, ref, defineModel, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  matrix: DestinyMatrix | undefined;
  hasPremiumAccess: boolean;
}>();
const isOpen = defineModel<boolean>({ default: false });
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!props.hasPremiumAccess) {
    isOpen.value = false;
  }
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(DestinyMatrixKeysEnum.HEALTH_MAP);
  }
}
</script>

<template>
  <AccordionComponent
    type="white"
    @opened="getData"
    v-model="isOpen"
    :isBlocked="!hasPremiumAccess"
  >
    <template #title>
      {{ t("calculators.destiny-matrix.accordions.health-map") }}
    </template>
    <template #faq-content>
      <div v-if="description" class="flex flex-col gap-2 sf-pro">
        <div class="whitespace-pre-line">
          {{ description["desc"] }}
        </div>
        <div class="flex flex-col gap-3">
          <div v-for="(chakra, key) in description['chakras']" :key="key">
            <p class="text-xl font-bold pt-4 mb-2">
              {{ chakra["name"] }}
            </p>
            <div class="whitespace-pre-line">
              {{ chakra["desc"] }}
            </div>
            <div
              v-for="(arcana, arcanaKey) in chakra['arcana']"
              :key="arcanaKey"
            >
              <p class="text-base font-semibold pt-2 mb-1">
                {{ arcana["title"] }}
              </p>
              <div class="whitespace-pre-line">
                {{ arcana["value"] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #collapse-text-btn>
      {{ t("calculators.destiny-matrix.accordions.collapse") }}
    </template>
  </AccordionComponent>
</template>
